<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit Customer</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="update">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Name<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.name.$model" type="text" label="Name" placeholder="Enter name" />
                            <div class="error" v-if="submitted && !$v.userdata.name.required">Please enter name</div>
                        </div>

                        <div class="col-md-4">
                            <label>Email<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.email.$model" type="text" label="Email" placeholder="Enter email" />
                            <div class="error" v-if="submitted && !$v.userdata.email.required">Please enter email</div>
                            <div class="error" v-if="submitted && !$v.userdata.email.email">Please enter valid email</div>

                        </div>
                        <div class="col-md-4">
                            <label>Mobile Number<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.number.$model" type="text" label="Number" placeholder="Enter mobile number" @keypress="onlyNumber" maxlength="10" />
                            <div class="error" v-if="submitted && !$v.userdata.number.required">Please enter mobile number</div>
                            <div class="error" v-if="submitted && !$v.userdata.number.minLength">Please enter valid mobile number</div>
                            <div class="error" v-if="submitted && !$v.userdata.number.maxLength">Please enter valid mobile number</div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-4">
                            <label for="country">Country<em style="color:red">*</em></label>
                            <select class="form-control first_null" v-model="userdata.country" @change="onChangeCountry" id="country">
                                <option value="" selected disabled>Select country</option>
                                <option v-for="(country, index) in listCountry" :value="country.country_name" :key="index">
                                    {{ country.country_name }}
                                </option>
                            </select>
                            <div v-if="submitted && !$v.userdata.country.required" class="error">Selct country</div>
                        </div>

                        <div class="col-md-4">
                            <label for="state">State<em style="color:red">*</em></label>
                            <select class="form-control first_null" v-model="userdata.state" :disabled="listState.length == 0" @change="onChangeState" id="state">
                                <option value="" selected disabled>Select state</option>
                                <option v-for="(state, index) in listState" :key="index" :value="state.state_name">
                                    {{ state.state_name }}
                                </option>
                            </select>
                            <div v-if="submitted && !$v.userdata.state.required" class="error">Select state</div>
                        </div>
                        <div class="col-md-4">
                            <label for="city">City<em style="color:red">*</em></label>
                            <select class="form-control first_null" v-model="userdata.city" :disabled="listCities.length == 0" id="city">
                                <option value="" selected disabled>Select city</option>
                                <option v-for="(city, index) in listCities" :key="index" :value="city.city_name">
                                    {{ city.city_name }}
                                </option>
                            </select>
                            <div v-if="submitted && !$v.userdata.city.required" class="error">Select city</div>
                        </div>
                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label for="pincode">Pincode<em style="color:red">*</em></label>
                            <input type="text" class="form-control" v-model="userdata.pincode" id="pincode" placeholder="Enter pincode" @keypress="onlyNumber" maxlength="6">
                            <div v-if="submitted && !$v.userdata.pincode.required" class="error">Pincode is required</div>
                        </div>

                        <div class="col-md-4">
                            <label for="appartment">HouseNo/Appartment<em style="color:red">*</em></label>
                            <input type="text" class="form-control" v-model="userdata.houseappartment" id="appartment" placeholder="Enter your houseno/appartment">
                            <div v-if="submitted && !$v.userdata.houseappartment.required" class="error">HouseNo/Appartment is required</div>
                        </div>

                        <div class="col-md-4">
                            <label for="area">Area<em style="color:red">*</em></label>
                            <input type="text" class="form-control" v-model="userdata.area" id="area" placeholder="Enter your area">
                            <div v-if="submitted && !$v.userdata.area.required" class="error">Area is required</div>
                        </div>
                    </div><br>

                    <div class="row">
                        <div class="col-md-4">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.userdata.status.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                                <option value="2">Block</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.userdata.status.required">Please select status</div>

                        </div>
                    </div>
                    <br />
                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                        <router-link to="/admin/dashboard/customer"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>
                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
    sameAs,
    email,
} from "vuelidate/lib/validators";
export default {
    name: 'editcustomer',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,
            listCountry: [],
            listState: [],
            listCities: [],
            authToken: "",
            userdata: {
                name: '',
                email: '',
                number: '',
                status: '',
                city: '',
                country: '',
                state: '',
                area: '',
                houseappartment: '',
                pincode: '',
                addressid:'',
            }
        }
    },

    validations: {
        userdata: {
            name: {
                required,
            },
            email: {
                required,
                email,
            },
            number: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            status: {
                required,
            },
            city: {
                required
            },
            country: {
                required
            },
            state: {
                required
            },
            area: {
                required
            },
            pincode: {
                required
            },
            houseappartment: {
                required
            },
        }
    },

    methods: {

        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },

        async loadCountry() {
            await this.axios
                .get("https://www.universal-tutorial.com/api/countries", {
                    headers: {
                        Authorization: `Bearer ${this.authToken}`,
                        Accept: "application/json",
                    },
                })
                .then((res) => {
                    this.listCountry = res.data;
                    this.onChangeCountry();

                });
        },
        async onChangeCountry() {
            await this.axios
                .get(
                    `https://www.universal-tutorial.com/api/states/${this.userdata.country}`, {
                        headers: {
                            Authorization: `Bearer ${this.authToken}`,
                            Accept: "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.listState = res.data;
                    this.onChangeState();

                });
        },
        async onChangeState() {
            await this.axios
                .get(
                    `https://www.universal-tutorial.com/api/cities/${this.userdata.state}`, {
                        headers: {
                            Authorization: `Bearer ${this.authToken}`,
                            Accept: "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.listCities = res.data;
                });
        },

        update() {
            this.submitted = true;
            this.$v.$touch()
            if (this.$v.$invalid) {
                return;
            } else {

                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/customer/update/` + this.$route.params.id, this.userdata)
                    .then(({
                        data
                    }) => {
                        this.$router.push('/admin/dashboard/customer');
                        this.flashMessage.success({
                            message: 'Customer Updated Successfully',
                        });
                    })
                    .catch((error) => {
                        if (error.response.data.errors.number) {
                            this.flashMessage.error({
                                message: 'The number has already been taken',
                            });
                        }
                        if (error.response.data.errors.email) {
                            this.flashMessage.error({
                                message: 'The email has already been taken',
                            });
                        }
                    });
            }
        }
    },

    async mounted() {
        const userdata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/customer/` + this.$route.params.id);
        this.userdata = userdata.data;

        await this.axios.get("https://www.universal-tutorial.com/api/getaccesstoken", {
                headers: {
                    Accept: "application/json",
                    "api-token": "jAJuES2nNREYu0qOJ9Sy6bydr_LPxmjv0jUAR-oEuXozRP_CjqPqRgp1mCPaNh8VPZo",
                    "user-email": "itjebasuthan@gmail.com",
                },
            })
            .then((res) => {
                this.authToken = res.data.auth_token;
                this.loadCountry();
            });
    },

};
</script>

<style lang="scss">
</style>
